import memoize from "lodash-es/memoize";
import { parseISO, format } from "date-fns";

export const createDateAsUTC = memoize(function createDateAsUTC(date: Date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
});

export function changeDatesToUTC(data: { [key: string]: any }) {
  Object.entries(data).forEach((v) => {
    let key = v[0];
    let val = v[1];
    if (val instanceof Date) data[key] = createDateAsUTC(val);
  });
}

export const readDate = memoize((str: string) => {
  const dt = new Date(str);
  return new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
});

export const dateToISOString = memoize(function dateToISOString(date: Date) {
  return date.toISOString();
});
export const dateToUTCString = memoize(function dateToUTCString(date: Date) {
  return date.toUTCString();
});

export const memoParseISO = memoize(parseISO);
export const formatGiorno = memoize(function formatGiorno(date?: Date): string {
  if (!date) return "";
  return format(date, "dd/MM/yyyy");
});
